'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable');
module.exports = function ColorPickerModel(colors, mapEditorModel) {
	let colorPickedHandler =  () => {},
		imagePickedHandler = () => {};
	const dispatcher = observable(this),
		completePick = (color, resolve, reject) => {
			dispatcher.dispatchEvent('hideColors');
			if (color !== undefined) {
				resolve(color);
			} else {
				reject();
			}
		},
		getColors = () => colors.slice(0),
		colorPicked = t => colorPickedHandler(t),
		pickColor = () => {
			dispatcher.dispatchEvent('hideImagePicker');
			dispatcher.dispatchEvent('showColors');
			return new Promise((resolve, reject) => {
				colorPickedHandler = (color) => completePick(color, resolve, reject);
				imagePickedHandler = () => {};
			});
		},
		colorPickCancelled = () => colorPickedHandler(),
		colorPickedDefault = () => colorPickedHandler(''),
		imagePicked = t => imagePickedHandler(t),
		pickColorOrImage = () => {
			dispatcher.dispatchEvent('showImagePicker');
			dispatcher.dispatchEvent('showColors');
			return new Promise((resolve, reject) => {
				colorPickedHandler = (color) => {
					if (color !== undefined) {
						completePick({color}, resolve, reject);
					} else {
						completePick(undefined, resolve, reject);
					}
				};
				imagePickedHandler = (image) => completePick({image}, resolve, reject);
			});
		},
		getInMapColors = () => {
			return mapEditorModel.getAllColors({maxColors: 35});
		};
	Object.freeze(Object.assign(this, {
		getColors, colorPicked, pickColor, colorPickCancelled, colorPickedDefault,
		pickColorOrImage, imagePicked, getInMapColors
	}));
};
